import React from "react";

export function ProofBand() {
  const stats = [
    { num: "5000+", label: "Chargers Deployed" },
    { num: "15+", label: "States Covered" },
    { num: "24/7", label: "Real Time Monitoring" },
    { num: "99.2%", label: "Network Uptime" },
  ];
  return (
    <div className="proof-band">
      <div className="container">
        <p className="section-label reveal" style={{ textAlign: "center", marginBottom: 32 }}>
          VerdeMobility in Numbers
        </p>
        <div className="proof-grid">
          {stats.map((s) => (
            <div className="proof-item reveal" key={s.label}>
              <div className="proof-num">{s.num}</div>
              <div className="proof-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function CTASection() {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-inner">
        <p className="section-label">Get In Touch</p>
        <h2 className="section-title">
          Ready to deploy<br />fast charging?
        </h2>
        <p className="section-sub">
          Whether it's a single unit or a large-scale charging network, our
          team will help you scope, install, and go live fast.
        </p>
        <div className="cta-form">
          <a
            href="/get-in-touch#contact-us"
            className="btn-primary"
            style={{ whiteSpace: "nowrap", textDecoration: "none" }}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ width: 18, height: 18 }}
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            Get a Quote
          </a>
        </div>
        <div className="cta-tags">
          <span className="cta-tag">Tailored Charging Solutions</span>
          <span className="cta-tag">Hassle-Free Installation</span>
          <span className="cta-tag">2-Year Warranty</span>
          <span className="cta-tag">48-Hour Response</span>
        </div>
        <div className="cta-stats">
          <div style={{ textAlign: "center" }}>
            <div className="cta-stat-num">5000+</div>
            <div className="cta-stat-label">Chargers Deployed</div>
          </div>
          <div className="cta-divider"></div>
          <div style={{ textAlign: "center" }}>
            <div className="cta-stat-num">15+</div>
            <div className="cta-stat-label">States Covered</div>
          </div>
          <div className="cta-divider"></div>
          <div style={{ textAlign: "center" }}>
            <div className="cta-stat-num">24/7</div>
            <div className="cta-stat-label">Real Time Monitoring</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            Verde<span>Mobility</span> — Think beyond EV Charging.
          </div>
          <ul className="footer-links">
            <li><a href="#">Products</a></li>
            <li><a href="#">Solutions</a></li>
            <li><a href="#">VerdeCMS</a></li>
            <li><a href="#">About</a></li>
            <li><a href="#">Contact</a></li>
          </ul>
          <div className="footer-copy">
            © 2026 VerdeMobility India Pvt. Ltd. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
